import { InjectionToken } from '@angular/core';
import { AppConfig } from '@shared/definitions';

export const APP_CONFIG = new InjectionToken<AppConfig>('app config');
